import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Card, Spinner } from '@lex/ui';
import { apiClient } from '../lib/api';

export function ArticlePage() {
  const { slug = '' } = useParams();
  const { data, isLoading, error } = useQuery({
    queryKey: ['article', slug],
    queryFn: () => apiClient.articles.get(slug),
    enabled: Boolean(slug),
  });

  if (isLoading) return <Spinner />;
  if (error || !data) {
    return <Card>Статья не найдена</Card>;
  }

  return (
    <article className="prose max-w-none">
      <h1 className="text-2xl font-bold text-slate-900">{data.title}</h1>
      <p className="mt-4 whitespace-pre-line text-slate-700">{data.body}</p>
    </article>
  );
}
